var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaUploadIconLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.623 31.846L36.25 42.474l10.628-10.628M36.25 38.6V12.735",
    stroke: "#D8E0FF",
    strokeWidth: 5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.541 41.749v14.62a2.024 2.024 0 01-2.024 2.024H13.984a2.025 2.025 0 01-2.024-2.025V41.75",
    stroke: "#D8E0FF",
    strokeWidth: 5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "media/images/MAUploadIconLight-700e90aa.svg";
export { SvgMaUploadIconLight as ReactComponent };